// Rithmo's own brand. The product mark is Rithmo's wave (public/rithmo-mark.png, the first Rithmo dashboard's
// logo), and an organization shows its own uploaded logo (Settings), else Rithmo's wave. The customer
// build also serves this file for the org chart's `../brand/OrgMark` (vite.config.ts), so the org chart shows
// the same logo.
import { useOrgLogo } from '../orgLogo'

/** Rithmo's mark: the wave. `size` is its height in pixels; the wave is about three times as wide. */
export function RithmoMark({ size = 32 }: { size?: number }) {
  return <img src="/rithmo-mark.png" alt="" aria-hidden="true" style={{ height: size }} className="w-auto shrink-0 object-contain" />
}

/** The Rithmo mark and name, as the first Rithmo dashboard shows them. `onDark` on the brand gradient. */
export function RithmoWordmark({ size = 32, onDark = false }: { size?: number; onDark?: boolean }) {
  return (
    <div className="flex items-center gap-3">
      {onDark ? (
        <span className="grid place-items-center rounded-xl bg-white px-2 shadow-sm" style={{ height: size + 8 }}><RithmoMark size={size - 6} /></span>
      ) : (
        <RithmoMark size={size} />
      )}
      <span className={`text-xl font-bold tracking-tight ${onDark ? 'text-white' : 'text-gray-900'}`}>Rithmo</span>
    </div>
  )
}

/** An organization's mark: its uploaded logo, or Rithmo's wave. */
export function OrgMark({ size = 36, logo }: { name: string; size?: number; logo?: string | null }) {
  const uploaded = useOrgLogo()
  const src = logo === undefined ? uploaded : logo
  if (src) {
    return (
      <span className="grid shrink-0 place-items-center overflow-hidden rounded-lg border border-gray-200 bg-white" style={{ width: size, height: size }}>
        <img src={src} alt="" aria-hidden="true" className="h-full w-full object-contain p-0.5" />
      </span>
    )
  }
  return (
    <span
      aria-hidden="true"
      className="grid shrink-0 place-items-center rounded-lg border border-gray-200 bg-white"
      style={{ width: size, height: size }}
    >
      <img src="/rithmo-mark.png" alt="" aria-hidden="true" style={{ width: Math.round(size * 0.8) }} className="h-auto object-contain" />
    </span>
  )
}

export function OrgWordmark({ name, subtitle }: { name: string; subtitle?: string }) {
  return (
    <div className="flex min-w-0 items-center gap-3">
      <OrgMark name={name} />
      <div className="min-w-0 leading-tight">
        <div className="truncate text-lg font-bold tracking-tight text-gray-900">{name}</div>
        {subtitle && <div className="text-xs font-medium text-gray-500">{subtitle}</div>}
      </div>
    </div>
  )
}
